$(document).on('click', '.js-load-btn', function(e) {
	e.preventDefault();
	const $this = $(this);
	const url = $this.attr('href');

	$.ajax({
		url: url,
		type: 'GET'
	}).done(function(data) {
		const buttonHtml = $(data).find('.js-blog-actions');
		const articleHtml = $(data).find('.article-item');
		articleHtml.addClass('transition-opacity');

		if (!buttonHtml.length) {
			articleHtml.removeClass('hidden');
		}

		$('.section-blog .section__actions').html(buttonHtml);

		$('.article-items')
			.find('.article-item.hidden')
			.addClass('transition-opacity')
			.removeClass('hidden');

		$('.article-items').append(articleHtml);

		setTimeout(function() {
			$('.article-item').removeClass('transition-opacity');
		}, 200);
	});
});
